<template>
  <div
    class="d-flex-column flex-85 justify-start align-start t-white gap-36 mobile-min-heigh"
  >
    <div class="path_of_exile_currency_boost">
      <CurrencyCard
        v-for="currency in paginatedData"
        :key="currency.id"
        :image="currency.icon"
        :title="currency.title"
        @click.stop="setActiveCurrency(currency.slug)"
        :price="currency.price"
      />
    </div>
    <div class="d-flex-row height-max-content">
      <Pagination
        :current-page="page"
        @pagechanged="onPageChange"
        :total-pages="totalPages"
      />
    </div>
  </div>
</template>

<script setup>
import CurrencyCard from "~/components/cards/CurrencyCard.vue";
import Pagination from "~/components/custom/Pagination.vue";
const gameStore = useGameStore();
const data = ref([]);

const router = useRouter();
const route = router.currentRoute;

const setActiveCurrency = (currency) => {
  router.push({
    path: route.value.path, // Keep the same path
    query: { ...route.query, active_currency: currency }, // Preserve existing queries and add/update currency
  });
};
const page = ref(1);
const limit = ref(10);
const fetchData = async () => {
  data.value = gameStore.getGamePack.prices;
};

const onPageChange = (pg) => {
  page.value = pg;
};
const totalPages = computed(() => Math.ceil(data.value.length / limit.value));

const paginatedData = computed(() => {
  const start = (page.value - 1) * limit.value;
  const end = start + limit.value;
  return data.value.slice(start, end);
});

await fetchData();
</script>
